import React from "react";
import "./ComponenteCSS/HeroImage.css";

const HeroImage = () => {
  return (
    <div className="hero-image-container">
      <img src="/assets/img/hero-image.png" alt="Hero" className="hero-image" />
    </div>
  );
};

export default HeroImage;
